const common = {
  siteName: "华丽的外出",
  siteTagline: "每一次出门都是时尚宣言",
  navHome: "首页",
  navCategories: "分类",
  navAbout: "关于我们",
  navContact: "联系我们",
  readMore: "阅读全文",
  backToHome: "返回首页",
  allRightsReserved: "版权所有",
  privacyPolicy: "隐私政策",
  termsOfService: "服务条款",
  subscribeNewsletter: "订阅资讯",
  subscribeDesc: "获取最新穿搭灵感与时尚资讯",
  emailPlaceholder: "请输入您的邮箱",
  subscribe: "订阅",
  search: "搜索",
  noResults: "暂无相关内容",
  loading: "加载中...",
  error: "加载失败，请稍后重试",
  scrollToTop: "返回顶部",
};

export default common;